// extracted by mini-css-extract-plugin
export var quillEditor = "_jr-1";
export var variable = "_jr-0";